﻿import '../../lib/confetti.min.js';
import './_ux-common.js';
import './_clicktocopy.js';
import './_checks.js';
import './_globalSearch.js';
import './_notifications.js';

globalThis.DsUtility = globalThis.DsUtility || {

    successColor: '#33b771',
    failColor: '#ff3333',

    pleaseWait: function () {

        $(document).on({
            ajaxStart: function () { pleaseWaitOn(); },
            ajaxStop: function () { pleaseWaitOff(); }
        });
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Add a recently viewed item to localstorage
    // └────────────────────────────────────────────────────────────────────
    addRecentlyViewed: function (type, id, name, description, image) {

        if (!window.tenantuid)
            return;

        const key = `recently_viewed_${window.tenantuid}`;

        if (!type || !name || !id) { return; }

        // Load existing list or start fresh
        let list = JSON.parse(localStorage.getItem(key)) || [];

        // Create the new item
        const item = { type: type, name: name, id: id, description: description, image: image, timestamp: Date.now() };

        // Remove any existing match (same type & id)
        list = list.filter(i => !(i.type === type && i.id === id));

        // Add new item to the front
        list.unshift(item);

        // Trim to max length 10
        if (list.length > 10) {
            list.pop();
        }

        // Save back to localStorage
        localStorage.setItem(key, JSON.stringify(list));
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Get the recently viewed items from localStorage
    // └────────────────────────────────────────────────────────────────────
    getRecentlyViewed: function (tenantuid) {

        if (!tenantuid)
            tenantuid = window.tenantuid;

        if (!tenantuid)
            return [];

        return JSON.parse(localStorage.getItem(`recently_viewed_${tenantuid}`)) || [];
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Remove a recently viewed item (matched by type & id) from localStorage
    // └────────────────────────────────────────────────────────────────────
    removeRecentlyViewed: function (type, id) {

        if (!window.tenantuid)
            return;

        const key = `recently_viewed_${window.tenantuid}`;

        // Ids come back from data attributes as strings, so compare as strings
        const list = (JSON.parse(localStorage.getItem(key)) || [])
            .filter(i => !(i.type === type && String(i.id) === String(id)));

        localStorage.setItem(key, JSON.stringify(list));
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Format a millisecond timestamp as a human-readable relative time
    // └────────────────────────────────────────────────────────────────────
    timeAgo: function (timestamp) {
        const seconds = Math.floor((Date.now() - timestamp) / 1000);
        if (seconds < 60) return 'just now';
        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return `${minutes} min ago`;
        const hours = Math.floor(minutes / 60);
        if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
        const days = Math.floor(hours / 24);
        return `${days} day${days !== 1 ? 's' : ''} ago`;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Animate a number counting up
    // └────────────────────────────────────────────────────────────────────
    animateNumber: function (elem, start, end, isMoney = false, duration = 500) {
        let current = start;
        const range = end - start;

        if (end == 0) {

            if (isMoney) {
                elem.textContent = "$0.00";
            } else {
                elem.textContent = "0";
            }

            return;
        }

        // Determine how many steps the animation will take
        const stepTime = Math.abs(Math.floor(duration / range));

        const timer = setInterval(() => {
            current += 1;

            if (isMoney) {
                elem.textContent = "$" + current.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
            } else {
                elem.textContent = current;
            }

            if (current == end) {
                clearInterval(timer);
            }
        }, stepTime);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Call when save a form starts
    // └────────────────────────────────────────────────────────────────────
    saveformStart: function (btn) {

        if (undefined === btn)
            btn = document.getElementById('saveButton');

        btn.disabled = true;
        btn.innerHTML = '<i class="fad fa-sync fa-spin" aria-hidden="true"></i>Saving...';
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Call when save a form succeeds
    // └────────────────────────────────────────────────────────────────────
    saveformSuccess: function (btn) {
        if (undefined === btn)
            btn = document.getElementById('saveButton');

        setTimeout(() => {
            DsUtility.notificationMessage(true, "Changes saved");
            DsUtility.saveformReset();
        }, 500);

    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Reset the save buttons
    // └────────────────────────────────────────────────────────────────────
    saveformReset: function (btn) {
        if (undefined === btn)
            btn = document.getElementById('saveButton');

        btn.disabled = false;
        btn.innerText = 'Save Changes';
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Show a popup in the middle of the screen
    // └────────────────────────────────────────────────────────────────────
    loginPopupOn: function (title, body) {
        window.heartbeat = "show";

        document.querySelector('.__ds_page_loading').innerHTML = "";
        document.querySelector('body').classList.add('loading');

        var d = document.querySelector('.__ds_page_loading');
        var c = document.createElement('div');
        c.classList.add('__ds_popup_login');
        c.innerHTML = `<h1>${title}</h1><p>${body}</p><span id="__ds_popup_login_timer">Checking again in 20 seconds</span>`;
        d.appendChild(c);

        let timeleft = 20;
        let timer = d.querySelector('#__ds_popup_login_timer');

        const interval = setInterval(function () {
            if (timeleft > 0) {
                timer.innerHTML = `Checking again in ${timeleft} seconds`;
            } else {

            }
            timeleft -= 1;
        }, 1000);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Hide a popup in the middle of the screen
    // └────────────────────────────────────────────────────────────────────
    loginPopupOff: function (fadeOut) {

        if (window.heartbeat !== "show")
            return;

        window.heartbeat = null;

        document.querySelector('body').classList.remove('loading');

        if (document.querySelector('.__ds_page_loading'))
            document.querySelector('.__ds_page_loading').innerHTML = "";
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Show a dismissable error popup in the middle of the screen
    // └────────────────────────────────────────────────────────────────────
    errorPopupOn: function (title, body) {
        document.querySelector('.__ds_page_loading').innerHTML = "";
        document.querySelector('body').classList.add('loading');

        const d = document.querySelector('.__ds_page_loading');
        const c = document.createElement('div');
        c.classList.add('__ds_popup_login');
        c.classList.add('error');

        const button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.setAttribute('class', 'close');
        button.setAttribute('data-dismiss', 'alert');
        button.innerHTML = '&times;';
        c.appendChild(button);

        const content = document.createElement('div');
        content.innerHTML = `<h1>${title}</h1>${body}`;
        c.appendChild(content);

        d.appendChild(c);


        button.addEventListener('click', () => {
            document.querySelector('body').classList.remove('loading');

            if (document.querySelector('.__ds_page_loading'))
                document.querySelector('.__ds_page_loading').innerHTML = "";
        })
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Displays confetti
    // └────────────────────────────────────────────────────────────────────
    confettiOn: function (settings, msg, comment, timeout, callback) {

        if (window.ConfettiGenerator === undefined)
            return;

        // hide please wait if enabled
        document.querySelector('.__ds_page_loading').innerHTML = "";

        document.querySelector('body').classList.add('loading');

        // do we have a canvas defined
        if ($('#confetti').length === 0) {
            var d = document.querySelector('.__ds_page_loading');
            var c = document.createElement('canvas');
            c.setAttribute('id', 'confetti');
            c.setAttribute('style', 'position: absolute;top: 0;');
            d.appendChild(c);
        }

        // If we have a message to show, display it wrapped in an h1 tag
        if (undefined !== msg && null !== msg && msg.length > 0) {
            var m = document.createElement('div');
            m.setAttribute('class', '__ds_page_confetti_message');
            m.innerHTML = `<h1 class="m-0">${msg}</h1>`;
            d.appendChild(m);

            // If we have a message comment to show, display it wrapped in an hr tag
            if (undefined !== comment && null !== comment && comment.length > 0) {
                m.innerHTML += `<h2 class="mt-2">${comment}</h2>`;
            }

        }

        if (undefined === settings || null === settings) {
            settings = { target: 'confetti' }
        }

        var confetti = new ConfettiGenerator(settings);

        confetti.render();

        $('#confetti').click(function () {
            if (undefined !== callback) {
                callback();
            }
            DsUtility.confettiOff(false);
        });


        if (undefined === timeout)
            timeout = 5000;

        setTimeout(function () {
            if (undefined !== callback) {
                callback();
            }
            DsUtility.confettiOff();
        }, timeout);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Hides confetti
    // └────────────────────────────────────────────────────────────────────
    confettiOff: function (fadeOut) {

        if (undefined === fadeOut)
            fadeOut = true;

        if (!fadeOut)
            document.querySelector('body').classList.remove('loading');

        $('.__ds_page_loading').fadeOut('slow', () => {
            $("body").removeClass("loading");


            var d = document.getElementsByClassName('__ds_page_loading')[0];
            while (d.firstChild) {
                $(d.firstChild).fadeOut();
                d.removeChild(d.firstChild);
            }

            d.removeAttribute('style');
        });
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Show an animated save confirmation
    // │
    // │ @msg - optional text message to be shown.
    // └────────────────────────────────────────────────────────────────────
    saveConfirmed: function (msg = 'Saved!', callback = undefined) {

        let body = document.querySelector('body');

        if (!msg)
            msg = 'Saved!';

        // Make sure we're not already showing something
        if (body.classList.contains('loading')) {
            var d = document.getElementsByClassName('__ds_page_loading')[0];
            while (d.firstChild) {
                d.removeChild(d.firstChild);
            }
        } else {
            body.classList.add('loading');
        }

        var d = document.getElementsByClassName('__ds_page_loading')[0];
        var c = document.createElement('div');
        c.setAttribute('class', '__ds_page_confirm_save_animation');
        d.appendChild(c);

        d.style.backgroundColor = "#fff";
        c.style.backgroundImage = `url('/Content/images/check_animation.gif?a=${Math.random()}')`;

        // Display the message
        var m = document.createElement('div');
        m.setAttribute('class', '__ds_page_loading_message');
        m.innerHTML = `<h1>${msg}</h1>`;
        d.appendChild(m);

        setTimeout(function () {
            if (undefined !== callback) {
                callback();
            }
            DsUtility.saveConfirmedOff();
        }, 2100);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Hides save confirmed
    // └────────────────────────────────────────────────────────────────────
    saveConfirmedOff: function (fadeOut = true) {

        if (undefined === fadeOut)
            fadeOut = true;

        if (!fadeOut)
            document.querySelector('body').classList.remove('loading');

        if (document.querySelector('.__ds_page_confirm_save_animation')) {
            document.querySelector('.__ds_page_confirm_save_animation').style.backgroundImage = '';
        }

        $('.__ds_page_loading').fadeOut('slow', () => {
            $("body").removeClass("loading");


            var d = document.getElementsByClassName('__ds_page_loading')[0];
            while (d.firstChild) {
                $(d.firstChild).fadeOut();
                d.removeChild(d.firstChild);
            }

            d.removeAttribute('style');
        });
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Enable the please wait animated image
    // │ 
    // │ @msg - optional text message to be shown.
    // │ @isTransparent - defaults to true, false sets background to white
    // └────────────────────────────────────────────────────────────────────
    pleaseWaitOn: function (msg, isTransparent) {

        // Make sure the please wait is not already on
        if ($("body").hasClass("loading")) {
            return;
        }

        document.querySelector('body').classList.add('loading');

        var d = document.getElementsByClassName('__ds_page_loading')[0];
        var c = document.createElement('div');
        c.setAttribute('class', '__ds_page_loading_animation');
        d.appendChild(c);

        // If we have a message to show, display it wrapped in an hr tag
        if (undefined === msg) {
            msg = 'Loading...';
        }

        // Display the message
        var m = document.createElement('div');
        m.setAttribute('class', '__ds_page_loading_message');
        m.innerHTML = "<h1>" + msg + "</h1>";
        d.appendChild(m);

        // If the isTransparent flag exists and is set to false, set the background to white
        if (undefined != isTransparent) {
            if (!isTransparent) {
                d.style.backgroundColor = '#fff'
            }
        }

    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Disables the please wait animated image
    // └────────────────────────────────────────────────────────────────────
    pleaseWaitOff: function (timeout = 1000, callback) {

        if (undefined === timeout)
            timeout = 0;

        // Add a delay
        setTimeout(function () {
            document.querySelector('body').classList.remove('loading');

            var d = document.getElementsByClassName('__ds_page_loading')[0];
            while (d.firstChild) {
                d.removeChild(d.firstChild);
            }

            // reset the background color
            d.style.backgroundColor = '';

            if (undefined !== callback) {
                callback();
            }
        }, timeout);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Displays a status message at the top of the screen
    // │ 
    // │ @message - text message to be shown. (required)
    // └────────────────────────────────────────────────────────────────────
    statusMessage: function (message) {

        var msg = null;

        if ($('#_ds__msg_status').length) {

            msg = $('#_ds__msg_status');

            // already created the div, let's just change the msg
            $('#msg-content').html(message);

        } else {

            msg = document.createElement('div');
            msg.setAttribute('id', '_ds__msg_status');
            msg.setAttribute('style', 'position:fixed; top:30px; left:0; width: 100%; padding-top: 0px; display:none;z-index: 9999;');

            let div = document.createElement('div');
            div.setAttribute('class', '_ds__msg_status_active');
            msg.appendChild(div);

            var span = document.createElement('span');
            span.setAttribute('id', 'msg-content');
            $(span).html(message);
            div.appendChild(span);

            var button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.setAttribute('class', 'close');
            button.setAttribute('data-dismiss', 'alert');
            $(button).html('&times;');
            div.appendChild(button);

            document.body.appendChild(msg);

            $(button).click(function () {
                $('#_ds__msg_status').remove();
            });

        }

        $(msg).fadeIn('slow');
        $(msg).delay(8000).fadeOut('slow');

    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Show a notification message to the user, such as when a
    // │ item like a poll gets saved.
    // │ 
    // │ @success - bool, true if this is a success. Otherwise false.
    // │ @message - message to display, shorter is better
    // └────────────────────────────────────────────────────────────────────
    notificationMessage: function (success, message) {

        this.addNotificationMessage();

        let notification = document.getElementById('_ds__msg_notification');
        notification.style.opacity = 1;

        let status = notification.querySelector('._ds__msg_notification_status');

        // clear status in case there are multiple calls
        notification.style.display = 'none';
        notification.querySelector('._ds__msg_notification_status').classList.remove('valid');
        notification.querySelector('._ds__msg_notification_status').classList.remove('invalid');
        notification.style.removeProperty('background-color');

        // set the ux based on success status
        if (success) {
            notification.querySelector('._ds__msg_notification_status').classList.add('valid');
        } else {
            notification.querySelector('._ds__msg_notification_status').classList.add('invalid');
            notification.style.backgroundColor = this.failColor;
        }

        document.querySelector('#_ds__msg_notification ._ds__msg_notification_title').innerText = message;
        document.getElementById('_ds__msg_notification').style.display = 'flex';

        setTimeout(function () {
            document.getElementById('_ds__msg_notification').style.opacity = 0;

            setTimeout(function () {
                document.getElementById('_ds__msg_notification').style.display = 'none';
            }, 600);

        }, 3000);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Generate unique identifier
    // │ 
    // │ @size - size of the uid to generate
    // └────────────────────────────────────────────────────────────────────
    generateUniqueId: function (size) {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        var id = '';

        for (var i = 0; i < size; i++) {
            id += s4();
        }

        return id;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Adds the HTML for the notification message to the page
    // └────────────────────────────────────────────────────────────────────
    addNotificationMessage: function () {

        // Did we already create this div?
        if ($('#_ds__msg_notification').length > 0)
            return;

        // Add the background div
        var msg = document.createElement('div');
        msg.setAttribute('id', '_ds__msg_notification');
        msg.setAttribute('class', '_ds__msg_notification_active');

        var div = document.createElement('div');
        div.setAttribute('class', '_ds__msg_notification_status');
        msg.appendChild(div);

        var content = document.createElement('div');
        content.setAttribute('class', '_ds__msg_notification_content');
        msg.appendChild(content);


        div = document.createElement('div');
        div.setAttribute('class', '_ds__msg_notification_title');
        content.appendChild(div);

        div = document.createElement('div');
        div.setAttribute('class', '_ds__msg_notification_clear');
        content.appendChild(div);

        document.body.appendChild(msg);
    },

    /*
    ------------------------------------------------------------
    Adds a message after the addFor element to present a warning
    or other message. Common use is during validation

    addFor - element this is added for
    message - message to display
    ------------------------------------------------------------
    */
    addInlineMessageError: function (addFor, message) {

        if (!message)
            return;

        // ensure we don't exist
        this.clearInlineMessage(addFor);

        let msg = null;

        if (addFor.dataset.validationtarget) {
            msg = document.getElementById(addFor.dataset.validationtarget);
        } else {
            msg = document.createElement('div');
            msg.id = addFor.id + '_error';
        }
        msg.classList.add('ds-ux-inline-msg');
        msg.classList.add('ds-ux-inline-error');
        msg.style.display = 'block';
        msg.innerHTML = `<i class="fas fa-exclamation-circle"></i>${message}`;

        // Dynamically insert after
        if (!addFor.dataset.validationtarget)
            $(msg).insertAfter($(addFor));

        // add the field-error class
        addFor.classList.add("field-error");

        console.log(message);
    },

    /*
    ------------------------------------------------------------
    Removes a message after removeFor

    removeFor - element this is after
    ------------------------------------------------------------
    */
    clearInlineMessage: function (removeFor) {

        if (!removeFor)
            return;

        removeFor.classList.remove("field-error");

        if ($(removeFor).next().hasClass('ds-ux-inline-msg')) {
            $(removeFor).next().remove()
        }

        if (removeFor.dataset && removeFor.dataset.validationtarget) {
            let msg = document.getElementById(removeFor.dataset.validationtarget);
            msg.style.display = 'none';
            msg.innerHTML = '';
        }
    },

    /*
    ------------------------------------------------------------
    Validates a select drop down list that a value is set other
    than what is specified.

    selectField - <select> element
    validIfNotValue - if the selected option is not this value

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateSelect: function (selectField, validIfNotValue) {
        var valid = false;

        if (null == $(selectField).val()) {
            valid = false;
        } else if (validIfNotValue != $(selectField).val()) {
            valid = true;
        }

        this.toggleValidateField(selectField, valid);

        return valid;
    },

    /*
    ------------------------------------------------------------
    Validates a URL Input type text and will set the
    field to invalid.

    txtField - <input type=text> element

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateTextFieldUrl: function (txtField, emptyIsValid) {
        var valid = this.validateUrl($(txtField).val());

        if (emptyIsValid && $(txtField).val() === '') {
            return true;
        }

        if (!valid) {
            this.toggleValidateField(txtField, false);
        } else {
            this.toggleValidateField(txtField, true);
        }

        return valid;
    },

    /*
    ------------------------------------------------------------
    Validates a Number Input type text and will set the
    field to invalid.

    txtField - <input type=text> element
    validateNumber - optionally use to validate vs the value of txtbox

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateTextFieldNumber: function (txtField, validateNumber) {
        var valid = null;

        if ((null == validateNumber) || (validateNumber.length <= 0)) {
            valid = this.validateNumber($(txtField).val());
        } else {
            valid = this.validateNumber(validateNumber);
        }

        if (!valid) {
            this.toggleValidateField(txtField, false);
        } else {
            this.toggleValidateField(txtField, true);
        }

        return valid;
    },

    /*
    ------------------------------------------------------------
    Validates an email addresses Input type text and will set the
    field to invalid.

    txtField - <input type=text> element

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateTextFieldEmail: function (txtField, emailAddress) {
        var valid = null;

        if (emailAddress) {
            valid = this.validateEmail(emailAddress);
        } else {
            valid = this.validateEmail($(txtField).val());
        }


        if (!valid) {
            this.toggleValidateField(txtField, false);
        } else {
            this.toggleValidateField(txtField, true);
        }

        return valid;
    },

    /*
    ------------------------------------------------------------
    Validates a phone number Input type text and will set the
    field to invalid.

    txtField - <input type=text> element

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateTextFieldPhone: function (txtField, phoneNumber) {
        var valid = null;

        if (phoneNumber) {
            valid = this.validatePhone(phoneNumber);
        } else {
            valid = this.validatePhone($(txtField).val());
        }


        if (!valid) {
            this.toggleValidateField(txtField, false);
        } else {
            this.toggleValidateField(txtField, true);
        }

        return valid;
    },

    /*
    ------------------------------------------------------------
    Validates that the validateString has a value and toggles
    the passed field.

    element - <input type=text> element

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateElementNotEmpty: function (element, validateString) {
        var valid = null;

        if ((null == validateString) || (validateString.length <= 0)) {
            valid = false;
        } else {
            valid = true
        }

        if (!valid) {
            this.toggleValidateField(element, false);
        } else {
            this.toggleValidateField(element, true);
        }

        return valid;
    },

    /*
    ------------------------------------------------------------
    Validates an Input type text has a valid length and will set the
    field to invalid.

    txtField - <input type=text> element
    length - contained text must be this length or longer

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateTextFieldNotEmpty: function (txtField, length) {
        var valid = false;
        let txt = '';

        if (undefined === length) {
            length = 1;
        }

        if (undefined === txtField.jquery) {
            txtField = $(txtField);
        }

        // remove whitespace
        if (typeof txtField.val() === 'string')
            txt = txtField.val().trim();
        else
            txt = txtField.val() || "";

        if (txt.length >= length) {
            valid = true;
        }

        if (!valid) {
            this.toggleValidateField(txtField, false);
        } else {
            this.toggleValidateField(txtField, true);
        }

        return valid;

    },

    /*
    ------------------------------------------------------------
    Toggles the validate class

    field - input type to toggle
    valid - bool to toggle on or off

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    toggleValidateField: function (field, valid) {

        if (undefined === field.jquery) {
            field = $(field);
        }

        const elem = document.getElementById($(field).prop("id"));
        if (!valid) {
            $(field).addClass('field-error');
            DsUtility.addInlineMessageError(elem, elem.dataset.validation);
        } else {
            $(field).removeClass('field-error');
            DsUtility.clearInlineMessage(elem);
        }
    },

    /*
    ------------------------------------------------------------
    Validates an email addresses

    email - email address to validate

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateEmail: function (email, emptyIsValid) {

        if (emptyIsValid && email === '') {
            return true;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (re.test(email))
            return true;

        return false;
    },

    /*
    ------------------------------------------------------------
    Validates a phone number

    phone - phone number to validate

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validatePhone: function (phone, emptyIsValid) {

        if (emptyIsValid && phone === '') {
            return true;
        }

        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

        if (re.test(phone))
            return true;

        return false;
    },

    /*
    ------------------------------------------------------------
    Validates a URL

    url - url to validate

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateUrl: function (url, emptyIsValid) {

        if (url.length === 0 && emptyIsValid)
            return true;

        if (!url)
            return false;

        url = url.toLowerCase();

        var urlRgx = /(sms|ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        var pathRgx = /^(\/\w+)+(\.)?\w+(\?(\w+=[\w\d]+(&\w+=[\w\d]+)*)+){0,1}$/;


        // if this is a full url
        if (urlRgx.test(url))
            return true;

        // if this is a valid path
        if (pathRgx.test(url))
            return true;

        return false;
    },

    /*
    ------------------------------------------------------------
    Validates a value is a number

    n - item to evaluate

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateNumber: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },

    /*
    ------------------------------------------------------------
    Validates a date - expects "mm/dd/yyyy"

    dateString - date to evaluate

    returns: true if valid, otherwise false
    ------------------------------------------------------------
    */
    validateDate: function (dateString) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
            return false;

        // Parse the date parts to integers
        var parts = dateString.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    },

    isDateValid: function (dateStr) {
        var date = new Date(dateStr);
        if (!isNaN(date)) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();


            // Check the ranges of month and year
            if (year < 1753 || year > 3000 || month == 0 || month > 12)
                return false;

            var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            // Adjust for leap years
            if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
                monthLength[1] = 29;

            // Check the range of the day
            return day > 0 && day <= monthLength[month - 1];

        }
        return false;
    },

    /*
    ------------------------------------------------------------
    Scrub down any input
    ------------------------------------------------------------
    */
    cleanInput: function (input, allowHtml) {
        // remove script tags
        input = input.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');

        // remove html
        if (!allowHtml) {
            input = input.replace(/(<([^>]+)>)/ig, '');
        }

        return input.trim();
    },

    htmlDecode: function (html) {
        var a = document.createElement('a'); a.innerHTML = html;
        return a.textContent;
    },


    /*
    ------------------------------------------------------------
    Gets a value from the querystring

    Example, DsUtility.getUrlVars()["pageIndex"];
    ------------------------------------------------------------
    */
    getUrlVars: function () {

        // Values?
        if (window.location.href.indexOf('?') < 0)
            return [];

        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {

            // fix bug where we may have multiple && in a user
            // edited search
            if (hashes[i].length > 0) {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
        }
        return vars;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Update a query string with new values
    // └────────────────────────────────────────────────────────────────────		
    updateQueryString: function (key, value, url) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        }
        else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Used to force a form submit
    // └────────────────────────────────────────────────────────────────────		
    formPost: function (path, params, method) {
        method = method || "post"; // Set method to post by default if not specified.

        // The rest of this code assumes you are not using a library.
        // It can be made less wordy if you use one.
        var form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", path);

        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Convert URL with parameters to an array
    // └────────────────────────────────────────────────────────────────────
    URLToArray: function (url) {
        var request = {};
        var pairs = url.substring(url.indexOf('?') + 1).split('&');

        for (var i = 0; i < pairs.length; i++) {
            if (!pairs[i]) { continue; }

            var pair = pairs[i].split('=');

            request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }

        return request;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Convert array of parameters back to URL friendly format
    // └────────────────────────────────────────────────────────────────────
    ArrayToURL: function (array) {
        var pairs = [];

        for (var key in array) {
            if (array.hasOwnProperty(key)) {
                pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(array[key]));
            }
        }

        return pairs.join('&');
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Removes a querystring parameter from the URL, this is used
    // │ when the dsid is passed in the url or an email address
    // │
    // │ @url - url to parse
    // │ @param - parameter to remove
    // └────────────────────────────────────────────────────────────────────
    removeURLParameter: function (url, param) {
        // Split the URL into the base and query string parts
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {
            // Split the query string using both '&' and ';'
            var queryString = urlparts[1];
            var pairs = queryString.split(/([&;])/);

            // Filter out the parameter to remove
            var prefix = encodeURIComponent(param) + '=';
            for (var i = pairs.length - 1; i >= 0; i--) {
                if (pairs[i].indexOf(prefix) === 0) {
                    pairs.splice(i, 2);
                }
            }

            // Reassemble the query string
            url = urlparts[0] + (pairs.length > 0 ? '?' + pairs.join('') : "");
            return url;
        } else {
            return url;
        }
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Handles setting history cookie
    // └────────────────────────────────────────────────────────────────────
    setHistory: function (path) {
        if (!path)
            return;

        if (0 !== path.indexOf('/'))
            return;

        DsUtility.setCookie('history_cookie', path, 20);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Handles getting/setting cookie and urls for history state returns path
    // │
    // │ Returns the path to the history if it exists
    // └────────────────────────────────────────────────────────────────────
    getHistory: function () {

        // used for setting the history cookie for account settings
        var d = document.getElementsByClassName("history_cookie");

        for (var i = 0; i < d.length; i++) {
            d[i].href += (d[i].href.indexOf('?') > 0) ? '&' : '?';
            d[i].href += `history_cookie=${location.pathname}`;
        }


        // check if we have a history cookie in the url
        var path = getHistoryCookieFromQueryString() || getCookie('history_cookie');

        // slide the expiration if we have a value
        if (path) {
            DsUtility.setCookie('history_cookie', path, 20);
        }

        return path;

        // ┌────────────────────────────────────────────────────────────────────
        // │ Retuns the value of the history_cookie and cleans the url
        // └────────────────────────────────────────────────────────────────────
        function getHistoryCookieFromQueryString() {
            var path = getQueryString('history_cookie');

            if (!path)
                return null;

            var url = DsUtility.removeURLParameter(document.URL, "history_cookie");
            window.history.replaceState(null, document.title, url);

            return path;
        }

        // ┌────────────────────────────────────────────────────────────────────
        // │ Helper method to get values from the query string
        // │
        // │ @field - name of query string field to return value of
        // │ returns: value of field or null if it does not exist
        // └────────────────────────────────────────────────────────────────────
        function getQueryString(field) {
            var href = window.location.href;
            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            var string = reg.exec(href);
            return string ? string[1] : null;
        }

        // ┌────────────────────────────────────────────────────────────────────
        // │ Get a cookie value by cookie name
        // └────────────────────────────────────────────────────────────────────
        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ if it’s not an English alphabet letter (A-Z or a-z), it replaces it with a random English letter
    // └────────────────────────────────────────────────────────────────────
    getEnglishCharOrRandom: function (char) {
        const isEnglishLetter = /^[A-Za-z]$/.test(char);
        if (isEnglishLetter) {
            return char;
        }

        const letters = "abcdefghijklmnopqrstuvwxyz";
        return letters[Math.floor(Math.random() * letters.length)];
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Set a cookie value by cookie name
    // │
    // │ @name - name of cookie
    // │ @value - value of cookie
    // │ @minutes - minutes until expires
    // └────────────────────────────────────────────────────────────────────
    setCookie: function (name, value, minutes) {
        var expires = "";
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Writes text to the user's clipboard, useful when we don't need clipboard.js
    // └────────────────────────────────────────────────────────────────────
    copyToClipboard: function (text) {

        if (!text)
            text = '';

        // Bit of a hack, but simpl option get into clipboard
        let tempInput = document.createElement("input");
        tempInput.style = "position: absolute; left: -1000px; top: -1000px";
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        let copied = document.execCommand("copy");
        document.body.removeChild(tempInput);

        return copied;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Validate that an MCE editor is not empty
    // └────────────────────────────────────────────────────────────────────
    isValidTinyMCE: function(editor) {

        if (!editor)
            return false;

        const elem = document.getElementById(editor.id);
        const ifrmElem = document.getElementById(editor.id + '_ifr'); 

        // do we require validation?
        if (!elem.classList.contains("validation"))
            return true;

        if (!elem)
            return false;

        //check empty body
        let isEmptyBody = false;
        let content = editor.getContent()
            .replaceAll('&nbsp;', '')
            .replaceAll('<br>','')
            .replaceAll(' ', '')
            .replaceAll('<p></p>', '').trim();

        if (content == "" || content == null) {
            isEmptyBody = true;
        }

        if (isEmptyBody) {
            ifrmElem.classList.add('field-error');
            DsUtility.addInlineMessageError(elem, elem.dataset.validation);
            return false;
        }

        ifrmElem.classList.remove('field-error');
        DsUtility.clearInlineMessage(elem);

        return true;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Looks at each element on the page containing the class 'validation' and checks if it is valid
    // | Iterates through each element within the specified form that has the class 'validation' and verifies its validity
    // └────────────────────────────────────────────────────────────────────
    isValid: function (selector_id) {
        let form = document.querySelector('#' + selector_id);
        let form_elements = selector_id ? form.querySelectorAll('.validation') : document.querySelectorAll('.validation');
        let is_valid = true;

        // Loop through each element
        for (var i = 0; i < form_elements.length; i++) {
            if (!DsUtility.isValidElement(form_elements[i]))
                is_valid = false;
        }

        return is_valid;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Looks at each element on the page containing the class 'validation' and checks if it is valid
    // └────────────────────────────────────────────────────────────────────
    isValidElement: function (form_element) {
        if (!form_element || null == form_element.offsetParent)
            return true;

        let is_valid = true;
        let allowblank = true;

        if (form_element.dataset.allowblank !== "true")
            allowblank = DsUtility.validateTextFieldNotEmpty(form_element);

        if (form_element.dataset.allowpersonalization === "true" && DsUtility.validatePersonalization(form_element))
            return true;

        // Handle validation for different form element types
        switch (form_element.type) {
            case "select-multiple":
                // Choices wraps the <select> in a .choices container; style that
                // (falls back to the element itself if it isn't a Choices select).
                if (!allowblank) {
                    $(form_element.closest('.choices') || form_element).addClass('field-error');
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    is_valid = false;
                } else {
                    $(form_element.closest('.choices') || form_element).removeClass('field-error')
                    DsUtility.clearInlineMessage(form_element);
                }
                break;
            case "select-one":
                if (!allowblank) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('change', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('change', DsUtility.validationEvent);
                }
                break;
            case "number":
                if (!allowblank || !DsUtility.validateNumber(form_element.value) || !DsUtility.validateLength(form_element) || !DsUtility.validateRange(form_element) || !DsUtility.validateMin(form_element)) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('input', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('input', DsUtility.validationEvent);
                }
                break;
            case "tel":
                if (!DsUtility.validatePhone(form_element.value, allowblank)) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('input', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('input', DsUtility.validationEvent);
                }
                break;
            case "email":
                if (!DsUtility.validateEmail(form_element.value, allowblank)) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('input', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('input', DsUtility.validationEvent);
                }
                break;
            case "url":
                if (!DsUtility.validateUrl(form_element.value, allowblank)) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('input', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('input', DsUtility.validationEvent);
                }
                break;
            case "password":
            case "text":
            case "date":
            case "time":
            case "textarea":
                if (!allowblank || !DsUtility.validateLength(form_element) || !DsUtility.validatePattern(form_element)) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('input', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('input', DsUtility.validationEvent);
                }
                break;
            case "checkbox":
                if (!form_element.checked) {
                    DsUtility.addInlineMessageError(form_element, form_element.dataset.validation);
                    form_element.addEventListener('input', DsUtility.validationEvent);
                    is_valid = false;
                } else {
                    DsUtility.clearInlineMessage(form_element);
                    form_element.removeEventListener('input', DsUtility.validationEvent);
                }
                break;
        }

        return is_valid;

    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ If element contains personalization script
    // └────────────────────────────────────────────────────────────────────
    validatePersonalization: function (element) {
        if (!element)
            return false;

        const regex = /^{{@?profile\..*}}$/;
        return regex.test(element.value);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ If element contains pattern for regex validation
    // └────────────────────────────────────────────────────────────────────
    validatePattern: function(element) {

        if (!element)
            return false;

        // does not use a regex pattern
        if (!element.pattern)
            return true;

        // check for the pattern
        let regex = new RegExp(element.pattern);

        return (regex.test(element.value));
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ If element contains data validation for length
    // └────────────────────────────────────────────────────────────────────
    validateLength: function (element) {

        if (!element)
            return false;

        let length = element.value.length;

        if (element.minLength >= 0 && length < element.minLength)
            return false;

        if (element.maxLength >= 0 && length > element.maxLength)
            return false;

        if (element.dataset.min_length && length < element.dataset.min_length)
            return false;

        if (element.dataset.max_length && length > element.dataset.max_length)
            return false;

        return true;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ If element is in a range, e.g. min/max on input type number
    // └────────────────────────────────────────────────────────────────────
    validateRange: function (element) {

        if (!element)
            return false;

        // if the element is not of type number return true
        if (element.type !== 'number')
            return true;

        let number = parseInt(element.value);
        let min = parseInt(element.min);
        let max = parseInt(element.max);

        // no range specified
        if (isNaN(min) || isNaN(max))
            return true;

        if ('undefined' === number || isNaN(number))
            return false;

        if (number < min)
            return false;

        if (number > max)
            return false;

        return true;
    },

    validateMin: function (element) {

        if (!element)
            return false;

        // if the element is not of type number return true
        if (element.type !== 'number')
            return true;

        let number = parseInt(element.value);
        let min = parseInt(element.min);

        // no min specified
        if (isNaN(min))
            return true;

        if ('undefined' === number || isNaN(number))
            return false;

        if (number < min)
            return false;

        return true;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Part of the validation logic
    // └────────────────────────────────────────────────────────────────────
    validationEvent: function (e) {
        e.target.classList.remove('field-error');
        DsUtility.clearInlineMessage(e.target);
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ HTML encode to prevent XSS
    // └────────────────────────────────────────────────────────────────────
    htmlEncode: function (input) {
        if (!input || input.length === 0)
            return input;

        input = input.replace(/&/g, '&amp;');
        input = input.replace(/</g, '&lt;');
        input = input.replace(/>/g, '&gt;');

        return input;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Pretty-format a phone number using intl-tel-input's utils.js.
    // │ utils.js loads from a CDN (and only after the page's own bundles),
    // │ so it may not be defined yet — or at all — when a DataTables render
    // │ fires. Guard it so a missing global falls back to the raw number
    // │ instead of throwing and breaking the entire table render.
    // └────────────────────────────────────────────────────────────────────
    formatPhone: function (number) {
        if (!number)
            return number;

        if (typeof intlTelInputUtils === 'undefined')
            return number;

        try {
            return intlTelInputUtils.formatNumber(
                number,
                null, // country code can be null for international numbers
                intlTelInputUtils.numberFormat.NATIONAL
            );
        } catch (e) {
            return number;
        }
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Create a GUID
    // └────────────────────────────────────────────────────────────────────
    newGuid: function () {

        // variable function used to generator random 4 character sequence
        var a = function () {
            return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1)
        };

        // this call builds the actual guid
        return a() + a() + "-" + a() + "-" + a() + "-" + a() + "-" + a() + a() + a()
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Save screenshot of asset
    // └────────────────────────────────────────────────────────────────────
    screenshot: function (settings) {

        if (!html2canvas) {
            console.warn('Cannot take screenshot - requires reference to html2canvas');
            return;
        }

        /*
            elem may be a function so a capture scheduled by screenshotIdle
            resolves the element when the capture runs rather than when it
            was scheduled.
        */
        if (typeof settings.elem === 'function') {
            settings.elem = settings.elem();
        }

        if (!settings.elem) {
            console.warn('Cannot take screenshot - requires reference to an HTML element');
            return;
        }

        if (!settings.assetType) {
            console.warn('Cannot take screenshot - requires assetType to be specified');
            return;
        }

        if (!settings.id) {
            console.warn('Cannot take screenshot - requires asset id to be specified');
            return;
        }

        // This capture replaces anything still waiting on the idle timer
        DsUtility.cancelScreenshotIdle(settings.assetType, settings.id);

        const key = `${settings.assetType}:${settings.id}`;

        // Let screenshotIdle see that a capture for this asset is running
        DsUtility._screenshotBusy[key] = Date.now();

        if (!settings.scale) {
            settings.scale = 1;
        }

        if (!settings.logging) {
            settings.logging = false;
        }

        if (!settings.width) {
            settings.width = settings.elem.offsetWidth;
        }

        if (!settings.height) {
            settings.height = settings.elem.offsetHeight;
        }

        /*
            Returned so a caller can tell when the capture is finished.

            html2canvas reads the DOM asynchronously, so anything moved out of
            the way for the capture - a transform, an overlay - cannot be put
            back on the next line. Nothing that ignores the return value is
            affected.
        */
        return html2canvas(settings.elem, {
            logging: settings.logging,
            scale: settings.scale,
            proxy: "/FileManager/ImageProxy",
            height: settings.height,
            width: settings.width,
            useCORS: false,
            imageTimeout: 15000
        }).then(canvas => {

            // Get base64URL
            var base64URL = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');

            if (!settings.assetType && !settings.id) {
                window.location.href = settings.path;
                return;
            }

            // Prepare data to send
            const data = {
                image: base64URL,
                assetType: settings.assetType,
                id: settings.id
            };

            // Send data using fetch
            fetch('/FileManager/UpdateAssetThumbnail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                if (settings.path) {
                    DsUtility.pleaseWaitOff();
                    window.location.href = settings.path;
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            })
            .finally(() => {
                delete DsUtility._screenshotBusy[key];
            });
        });
    },

    // ┌────────────────────────────────────────────────────────────────
    // │ Captures waiting on the idle timer, and captures already running,
    // │ keyed by asset type and id
    // └────────────────────────────────────────────────────────────────
    _screenshotIdleTimers: {},
    _screenshotBusy: {},

    /*
        Capture a thumbnail once editing has stopped.

        A designer autosaves every few seconds while someone is working, and
        each capture costs the server a second or two to decode and store, so
        capturing on every autosave is nearly all wasted work - only the last
        capture of an editing burst is ever looked at. Each call pushes the
        capture out by settings.idle ms (default 15s), so a single capture
        runs once the saves stop. An explicit DsUtility.screenshot for the
        same asset replaces whatever is waiting.

        Takes the same settings as screenshot, where elem may also be a
        function so the element is resolved when the capture runs.
    */
    screenshotIdle: function (settings) {

        if (!settings || !settings.assetType || !settings.id) {
            console.warn('Cannot schedule screenshot - requires assetType and asset id to be specified');
            return;
        }

        const key = `${settings.assetType}:${settings.id}`;
        const idle = settings.idle || 15000;

        clearTimeout(DsUtility._screenshotIdleTimers[key]);

        DsUtility._screenshotIdleTimers[key] = setTimeout(function () {

            const startedAt = DsUtility._screenshotBusy[key];

            /*
                A capture for this asset is still running - wait out another
                idle period instead of stacking a second render on top of it.
                A capture that never reported back is treated as gone after a
                minute so a failed one cannot block every later capture.
            */
            if (startedAt && Date.now() - startedAt < 60000) {
                DsUtility.screenshotIdle(settings);
                return;
            }

            delete DsUtility._screenshotIdleTimers[key];

            // screenshot fills in defaults, so hand it a copy of the settings
            DsUtility.screenshot(Object.assign({}, settings));

        }, idle);
    },

    // ┌────────────────────────────────────────────────────────────────
    // │ Drop the capture waiting on the idle timer for an asset, if any
    // └────────────────────────────────────────────────────────────────
    cancelScreenshotIdle: function (assetType, id) {

        const key = `${assetType}:${id}`;

        clearTimeout(DsUtility._screenshotIdleTimers[key]);
        delete DsUtility._screenshotIdleTimers[key];
    },
    // ┌────────────────────────────────────────────────────────────────────
    // │ initialization https://intl-tel-input.com/
    // │ 
    // │ @inputName - input name
    // │ @placeholderNumberType - number type to use for placeholders
    // └────────────────────────────────────────────────────────────────────
    initIntlTel: function (inputName, placeholderNumberType) {
        var input = document.querySelector(inputName);
        var iti = window.intlTelInput(input, {
            // allowDropdown: false,
            // autoHideDialCode: false,
            // autoPlaceholder: "off",
            // dropdownContainer: document.body,
            // excludeCountries: ["us"],
            // formatOnDisplay: false,
            // geoIpLookup: function(callback) {
            //   $.get("http://ipinfo.io", function() {}, "jsonp").always(function(resp) {
            //     var countryCode = (resp && resp.country) ? resp.country : "";
            //     callback(countryCode);
            //   });
            // },
            // hiddenInput: "full_number",
            // initialCountry: "us",
            // localizedCountries: { 'de': 'Deutschland' },
            // nationalMode: false,
            // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
            placeholderNumberType: placeholderNumberType,
            // preferredCountries: ['cn', 'jp'],
            separateDialCode: true,
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.15/js/utils.min.js",
        });
        return iti;
    },
    isNumber: function (evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    },

    /**
     * Attempts to toggle a floatbox open or closed
     * @param {any} target
     * @returns
     */
    toggleCollapse: function (target) {
        const floatbox = target.closest('.floatbox');
        const collapse = floatbox.querySelector('.collapse');
        const icon = floatbox.querySelector('.panel_expand_toggle');

        if (!collapse) return;

        // Use a unique ID or title as the key for Local Storage
        const storageKey = 'floatbox_state_' + (floatbox.id || floatbox.querySelector('.panel_title')?.innerText.trim());

        if (icon.classList.contains('fa-angle-up')) {
            $(collapse).collapse('show');
            icon.classList.replace('fa-angle-up', 'fa-angle-down');

            // Save state as 'expanded'
            localStorage.setItem(storageKey, 'expanded');
        } else {
            $(collapse).collapse('hide');
            icon.classList.replace('fa-angle-down', 'fa-angle-up');

            // Save state as 'collapsed'
            localStorage.setItem(storageKey, 'collapsed');
        }
    },

    toHHMMSS: function (date) {        
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();

        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        return hours + ':' + minutes + ':' + seconds;
    },

    // ┌────────────────────────────────────────────────────────────────────
    // │ Setup a dropdown button
    // └────────────────────────────────────────────────────────────────────
    dropdownButton: function (dropdown) {
        const select = dropdown.querySelector(".select");
        const caret = dropdown.querySelector(".caret");
        const menu = dropdown.querySelector(".menu");
        const selected = dropdown.querySelector(".selected");

        // Define a property with a setter
        Object.defineProperty(dropdown, 'value', {
            get: function () {
                return this._customProperty;
            },
            set: function (value) {
                this._customProperty = value;

                const li = this.querySelector(`li[data-value="${value}"]`);

                if (li)
                    this.querySelector('.selected').innerText = li.innerText;
            }
        });

        menu.addEventListener("click", (e) => {
            const option = e.target.closest("li");
            if (!option || !menu.contains(option)) return;

            selected.innerText = option.innerText;
            dropdown.value = option.dataset.value;

            select.classList.remove("select-clicked");
            caret.classList.remove("caret-rotate");
            menu.classList.remove("menu-open");

            // update active state using CURRENT lis
            menu.querySelectorAll("li").forEach(li => li.classList.remove("active"));
            option.classList.add("active");

            raiseCustomChangeEvent(dropdown, dropdown.value);
        });

        select.addEventListener("click", () => {
            select.classList.toggle("select-clicked");
            caret.classList.toggle("caret-rotate");
            menu.classList.toggle("menu-open")
        });

        function raiseCustomChangeEvent(element, data) {
            // Create a custom change event with some custom data
            const event = new CustomEvent('change', {
                detail: data, // Custom data stored in the 'detail' property
                bubbles: true,     // The event will bubble up through the DOM
                cancelable: true   // The event can be canceled
            });

            // Dispatch the event on the specified element
            element.dispatchEvent(event);
        }

        document.addEventListener('click', (e) => {
            // close all buttons
            const buttons = document.querySelectorAll(".dropdown-button");

            buttons.forEach(button => {

                if (!button.contains(e.target)) {
                    if (button.querySelector('.select.select-clicked'))
                        button.querySelector('.select').classList.toggle("select-clicked");

                    if (button.querySelector('.caret.caret-rotate'))
                        button.querySelector('.caret').classList.toggle("caret-rotate");

                    if (button.querySelector('.menu.menu-open'))
                        button.querySelector('.menu').classList.toggle("menu-open");

                }

            });

        });
    },

    /**
     * Checks and sets the toggle state for all floatboxes
     */
    setToggleState: function() {
        document.querySelectorAll('.floatbox').forEach(floatbox => {
            // Generate the unique key for this specific floatbox
            const panelTitle = floatbox.querySelector('.panel_title');
            const storageKey = 'floatbox_state_' + (floatbox.id || panelTitle?.innerText.trim());

            // Retrieve the saved preference
            const savedState = localStorage.getItem(storageKey);

            // Find the internal elements
            const collapseEl = floatbox.querySelector('.collapse');
            const icon = floatbox.querySelector('.panel_expand_toggle');

            if (savedState && collapseEl && icon) {

                if (savedState === 'collapsed') {
                    $(collapseEl).collapse('hide');
                    icon.classList.replace('fa-angle-down', 'fa-angle-up');
                } else {
                    $(collapseEl).collapse('show');
                    icon.classList.replace('fa-angle-up', 'fa-angle-down');
                }
            }
        });
    }
};

// ┌────────────────────────────────────────────────────────────────────
// │ Global events
// └────────────────────────────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {

    // ┌────────────────────────────────────────────────────────────────────
    // │ Handle special click events - ensure is only added once
    // └────────────────────────────────────────────────────────────────────
    if (!document.hasGlobalClickHandler) {
        document.hasGlobalClickHandler = true;
        document.addEventListener('click', globalClickHandler);
    }

    DsUtility.setToggleState();
    setRequiredFields();
    setupDropdownButtons();

    // ┌────────────────────────────────────────────────────────────────────
    // │ Look for <label> associated with an input that has a "validation" 
    // │ class and add an asterick to indicate it is required
    // └────────────────────────────────────────────────────────────────────
    function setRequiredFields() {

        let fields = document.querySelectorAll('.validation');

        for (let i = 0; i < fields.length; i++) {

            // the field must have an id since this will be used to find the associated label
            if (!fields[i].id)
                continue;

            // If the field has allowblank, skip
            if (fields[i].dataset.allowblank === "true" || fields[i].dataset.allowblank === true)
                continue;

            // attempt to find the label
            let label = document.querySelector(`label[for=${fields[i].id}]`);

            // no label, skip
            if (!label)
                continue;

            // already has an * in the label
            if (label.innerHTML.indexOf("*") >= 0)
                continue;

            label.innerHTML += '<span class="field-required">*</span>';
        }
    }

    function globalClickHandler(e) {
        // ┌────────────────────────────────────────────────────────────────────
        // │ Copy tracking link to the clipboard
        // │
        // │ Usage:
        // │ class="clipboard_copy" data-clipboard="[value]" or data-target="[class or id]"
        // └────────────────────────────────────────────────────────────────────
        if (e.target.classList.contains('clipboard_copy')) {
            e.preventDefault();
            console.log("click");

            let text = '';

            // either have a target or a clipboard value
            if (e.target.dataset.target) {

                let elem = document.querySelector(e.target.dataset.target);

                switch (elem.tagName) {
                    case "A":
                        text = elem.href;
                        break;
                    default:
                        text = elem.value;
                        break;
                }
            } else {
                text = e.target.dataset.clipboard;
            }

            if (text) {
                navigator.clipboard.writeText(text);
                DsUtility.notificationMessage(true, "Copied to clipboard");
            }
        }

        // ┌────────────────────────────────────────────────────────────────────
        // │ Toggles an input from password to text
        // │
        // │ Usage:
        // │ class="password_reveal" data-clipboard="[value]" or data-target="[class or id]"
        // └────────────────────────────────────────────────────────────────────
        if (e.target.classList.contains('password_reveal')) {
            e.preventDefault();

            const parent = e.target.parentNode;
            const input = parent.querySelector('input')

            if (e.target.classList.contains('fa-eye-slash')) {
                e.target.classList.remove('fa-eye-slash');
                e.target.classList.add('fa-eye');
                input.type = "text";
            } else {
                e.target.classList.remove('fa-eye');
                e.target.classList.add('fa-eye-slash');
                input.type = "password";
            }
        }

        /**
         * Expand/Collapse panels
         * 
         * Usage:
         * class="clipboard_copy" data-clipboard="[value]" or data-target="[class or id]"
         */
        // The whole header is the click target, not just the chevron: when the
        // Font Awesome kit fails to load (blocked by an extension or network
        // filter) the <i> renders empty and zero-width, leaving nothing to click (#9614).
        const header = e.target.closest('.floatbox-header');
        if (header && header.querySelector('.panel_expand_toggle')
            && !e.target.closest('a, button, input, select, textarea, label')) {

            DsUtility.toggleCollapse(header);
        }
    }

    // ┌────────────────────────────────────────────────────────────────────
    // │ Replaces <select> dropdown
    // └────────────────────────────────────────────────────────────────────
    function setupDropdownButtons() {
        const buttons = document.querySelectorAll(".dropdown-button");

        buttons.forEach(dropdown => {

            if (dropdown.dataset.autosetup !== 'false')
                DsUtility.dropdownButton(dropdown);
        });
    }

});

// ┌────────────────────────────────────────────────────────────────────
// │ force cursor to end of selection on textbox
// └────────────────────────────────────────────────────────────────────	
(function ($) {
    $.fn.focusTextToEnd = function () {
        this.focus();
        var $thisVal = this.val();
        this.val('').val($thisVal);
        return this;
    };

    // ┌────────────────────────────────────────────────────────────────────
    // │ setup any global events
    // └────────────────────────────────────────────────────────────────────
    $(document).ready(function () {
        setupCloseButtons();
    });

    // ┌────────────────────────────────────────────────────────────────────
    // │ Sets the href for any close buttons to use the history state
    // └────────────────────────────────────────────────────────────────────
    function setupCloseButtons() {

        // get/set any history state used for close buttons to return back to previous screen
        var path = DsUtility.getHistory();

        if (!path)
            return;

        if ($('.closeButton').length === 0)
            return;

        $('.closeButton').attr('href', path);

        $('.closeButton').click(() => {
            DsUtility.setCookie('history_cookie', '', 0);
        });
    }

    // ┌────────────────────────────────────────────────────────────────────
    // │ Set a cookie value by cookie name
    // │
    // │ @name - name of cookie
    // │ @value - value of cookie
    // │ @minutes - minutes until expires
    // └────────────────────────────────────────────────────────────────────
    function setCookie(name, value, minutes) {
        var expires = "";
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }


}(jQuery));